export default __webpack_public_path__ + "static/media/Hammer of the Rhino Rider.7e805ae4.jpg";